module.exports = __webpack_public_path__ + "fonts/Avenir85.73995e89.ttf";